export default __webpack_public_path__ + "static/media/border_blue.83984a48.svg";